/**
 * Rosie — NEMT Dispatch Platform
 * Copyright (c) 2025-2026 Commonwealth Transport LLC. All rights reserved.
 * PROPRIETARY AND CONFIDENTIAL. Unauthorized use, copying, or distribution is prohibited.
 */
import api from './api';

// Approve a trip, handling the pay-before-accept gate (Paula 2026-11-03):
// approving an unpaid self-booked ride accepts it PENDING PAYMENT -- the
// server emails the customer the pay link and auto-cancels it if unpaid an
// hour later. Say so, so nobody thinks it is fully confirmed. Returns true
// once approved. Other errors are thrown.
export default async function approveTrip(tripId, approvedBy = 'paula') {
  try {
    const res = await api.put(`/transports/${tripId}/approve`, { approvedBy });
    if (res.data && res.data.pendingPayment) {
      const due = res.data.dueAt
        ? new Date(res.data.dueAt).toLocaleTimeString('en-US', { timeZone: 'America/New_York', hour: 'numeric', minute: '2-digit' })
        : 'an hour from now';
      window.alert(
        'Accepted PENDING PAYMENT' + (res.data.amount ? ' ($' + Number(res.data.amount).toFixed(2) + ')' : '') + '.\n\n' +
        (res.data.alreadyAccepted ? 'The customer already has the pay link. ' :
          (res.data.emailed ? 'The customer was emailed the pay link. ' : 'NO customer email on file -- call them with the pay link. ')) +
        'If it is not paid by ' + due + ', Rosie cancels it automatically. No driver goes on it until it is paid.\n\n' +
        'To run it without payment instead, tell Rosie chat "run it unpaid".');
    }
    return true;
  } catch (err) {
    if (err.response?.status === 409 && err.response.data?.requiresPaymentAck) {
      if (!window.confirm(err.response.data.message)) return false;
      await api.put(`/transports/${tripId}/approve`, { approvedBy, acceptUnpaid: true });
      return true;
    }
    throw err;
  }
}
